import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "src/components/Layout";

const LayoutWithSidebar = () => <Layout withSidebar />;

export const Route = createFileRoute("/_layout")({
    component: LayoutWithSidebar,
});
